import { Chip } from "@mui/material";
import { useRecordContext } from "react-admin";
import { ENTITY_TYPE_OPTIONS } from "@/constants/entityType";

const EntityTypeChip = ({ source }: { source: string }) => {
  const record = useRecordContext();

  if (!record || !record[source]) return null;

  const value = record[source];
  const match = ENTITY_TYPE_OPTIONS.find((option) => option.value === value);

  return (
    <Chip
      label={match ? match.label : value}
      color="primary"
      size="small"
      variant="outlined"
    />
  );
};

export default EntityTypeChip;
